applyDiff